import { FC } from "react";
import { Button, ButtonSize, ButtonVariant } from "shared/components";
import { XClose } from "untitledui-js-base";
import { NotesList } from "./NotesList";
import Drawer from "react-modern-drawer";
import { useNotes } from "shared/queries/useNotes";
import { Loader } from "shared/components/Loader";
import { useMedia } from "shared/providers";

type Props = {
  showNotes: boolean;
  setShowNotes: (value: boolean) => void;
  applicationId: string;
};

export const NotesDrawer: FC<Props> = ({
  showNotes,
  setShowNotes,
  applicationId
}) => {
  const {
    data: notes,
    refetch: refetchNotes,
    isLoading
  } = useNotes(applicationId);

  const { isMobile } = useMedia();

  return (
    <Drawer
      className="rounded-l-lg"
      direction="right"
      onClose={() => {
        setShowNotes(false);
      }}
      open={showNotes}
      size={isMobile ? 380 : 480}
    >
      <div className="flex h-screen flex-col">
        <div className="flex items-center justify-between border-b border-alpha-80 px-6 py-4">
          <p className="text-xl font-bold text-content-1000">
            Application notes
          </p>
          <Button
            variant={ButtonVariant.BASE}
            size={ButtonSize.SM}
            borderLess
            className="!justify-end stroke-content-1000 !p-0"
            onClick={() => setShowNotes(false)}
          >
            <XClose size="24" />
          </Button>
        </div>
        <div className="flex-grow overflow-y-auto">
          {isLoading ? (
            <div className="flex items-center justify-center pt-10">
              <Loader />
            </div>
          ) : (
            <NotesList
              notes={notes || []}
              refetchNotes={refetchNotes}
              closeNotesDrawer={() => setShowNotes(false)}
            />
          )}
        </div>
      </div>
    </Drawer>
  );
};
